module.exports = __webpack_public_path__ + "static/media/loader.68e2ca2b.gif";